<div [class]="customClasses().formGroup">
  <label [class]="customClasses().label" [class.disabled]="ngControl.disabled">
    {{ label() }}
    @if (inputRequiredIndicatorEnabled()) {
      <span class="text-danger"> *</span>
    }
  </label>

  <ng-select
    [items]="list()"
    [bindValue]="valueField()"
    [bindLabel]="labelField()"
    [placeholder]="placeholder()"
    [formControl]="ngControl.control | formControl"
    [multiple]="multiple()"
    [searchable]="searchable()"
    [clearable]="clearable()"
    [appendTo]="appendTo() ?? ''"
    [class.is-invalid]="ngControl.touched && ngControl.invalid"
    [attr.data-qa]="testAutomationSelectorName()"
    (change)="onChange($event)"
    (clear)="onClear()"
  ></ng-select>

  <div class="field-error-slot">
    @if (ngControl.touched && ngControl.control?.errors?.['required']) {
      <div class="invalid-feedback d-block">Please select a {{ label() | lowercase }}</div>
    }
  </div>
</div>
